export const SLICES = {
  HUB_PREVIOUS: 'SLICES_HUB_PREVIOUS',
  HUB_NEXT: 'SLICES_HUB_NEXT',
  HUB_NO_RESULTS: 'SLICES_HUB_NO_RESULTS',
};
